WiseMetering.Model.Notification = WiseMetering.Model.extend({
    urlRoot: '/notifications',

    status: function() {
        return this.get('read') ? 'read' : 'unread';
    }
});
